import React from 'react'
import { MenuItem } from '@material-ui/core'
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';
import DropDownIconButton from "src/components/common/DropDownIconButton";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles({
    downloadIcon: {
        color: "#3474b4"
    }
});

interface DropDownMenuItem {
    id: string,
    label: string,
    onClick: () => void
}

type DownloadDropDownIconButtonProps = {
    options: DropDownMenuItem[],
    disabled: boolean
}

/**
 * The Component is used to provide download icon with a list og dropdown menu.
 */
const DownloadDropDownIconButton: React.FunctionComponent<DownloadDropDownIconButtonProps> = (props: DownloadDropDownIconButtonProps) => {
    const styles = useStyles();

    const listOfOptions =
        props.options.map((option) => (
            <MenuItem
                key={option.id}
                onClick={option.onClick}>
                {option.label}
            </MenuItem>
        ));

    return (
        <DropDownIconButton
            buttonTooltipText="Download"
            disabled={props.disabled}
            iconNode={<CloudDownloadIcon className={props.disabled ? '' : styles.downloadIcon}/>}
            childrenNode={listOfOptions}/>
    );
}

export default DownloadDropDownIconButton;